package fr.frux.core.common.config

/**
 * Le web n'a pas de mécanisme de version généré à la compilation (pas de `package.json` versionné
 * en usage, contrairement à `window.fruxApiBaseUrl` qui est posé par la page hôte) : constante
 * alignée à la main sur `versionName` (androidApp/build.gradle.kts) et `MARKETING_VERSION`
 * (iosApp.xcodeproj) tant qu'aucun mécanisme de génération n'existe (#91).
 */
actual fun appVersion(): String = "1.0.0"
